import React, { FC } from 'react'
import useViewContext from '@modules/order/hooks/use-view-context'
import * as css from './QuantityHeaderWithKPI.css'
import classNames from 'classnames'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { useTranslation } from 'react-i18next'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { useObserver } from 'mobx-react-lite'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import { nav } from '@stores'

export interface CellProps {
  header?: any
  doorOrderId?: string
}

const QuantityKPICell: FC<CellProps> = ({ header, doorOrderId }) =>
  useObserver(function useHook() {
    const { t } = useTranslation()
    const viewContextVal = useViewContext()
    const store = viewContextVal.uiStore as EnhancedListUIStore<any>
    const { getHeaderDoorKpis } = store
    const {
      uiStore: {
        dataStore: { summary },
        quantityTypeStore: { type }
      }
    } = useOrderContext()

    const currency = getKPICurrency(nav.queryParams.orderType, summary)
    const doorKpi = doorOrderId ? getHeaderDoorKpis(doorOrderId, type, currency) : null
    return (
      <>
        <div className={classNames(css.qtyCellWrapper, css.enhancedCellBorder)}>
          <span className={css.cell}>
            <Typography variant={doorKpi?.[header.field] ? 'subtitle1' : 'subtitle2'}>
              {doorKpi?.[header.field] ??
                t(`order.otbHeaders.label.${header.key}`, header.label)}
            </Typography>
          </span>
        </div>
      </>
    )
  })

export default QuantityKPICell
